import { render, staticRenderFns } from "./PractitionerTable.vue?vue&type=template&id=38067b9c&"
import script from "./PractitionerTable.vue?vue&type=script&lang=ts&"
export * from "./PractitionerTable.vue?vue&type=script&lang=ts&"
import style0 from "./PractitionerTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports